import paymentDetail from './payment-detail.vue'
import paymentActions from './payment_actions.vue'
import NewPaymentForm from './new_payment_form.vue'
import paymentInvoicesTablePanel from './payment-invoices-table-panel.vue'
export default{
  'payment-detail': paymentDetail,
  'payment-actions': paymentActions,
  'payment-invoices-table-panel': paymentInvoicesTablePanel,
  'new-payment-form': NewPaymentForm,
}